import { useCallback, useEffect, useState } from 'react'

import { useRefundPoints } from '../../refundPoints/useRefundPoints'

import { RefundPointSummary } from '../../../types/refundPoint/refundPoint'
import { WidgetDataResult } from '../../../types/widget/widget'

/** The customer's refund point balance, shaped as a dashboard widget result. */
export const useRefundPointsWidget = (): WidgetDataResult<RefundPointSummary> => {
  const { summary } = useRefundPoints()
  const [data, setData] = useState<RefundPointSummary | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      setData(await summary())
    } catch (caught) {
      setError((caught as Error).message)
    } finally {
      setLoading(false)
    }
  }, [summary])

  useEffect(() => {
    refetch()
  }, [refetch])

  return { data, loading, error, refetch, resetState: () => setError(null) }
}
